import styled from 'styled-components';

export const Heading = styled.h6`
  padding-left: 16px;
  font-weight: 700;
  font-size: 16px;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  max-height: 100%;
`;

export const MenuHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  max-height: 100%;
  max-width: 100%;
`;

export const OnlyAvatarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 100%;
  max-width: 100%;
`;
